export const DISPLAY_CANVAS_VERTICAL_LIMITS = false;
export const DISPLAY_CAMERA_HELPER = false;
export const DISPLAY_CAMERA_BOUNDARY_HELPER = false;
export const DISPLAY_FOCUS_CROSS = false;
export const DISPLAY_SCROLL_BOUNDARY_HELPER = false;
